import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AttendanceDetailEditModeSearchSchema } from '../../-shared/attendance-detail-edit-mode-search-schema';
export const Route = createFileRoute('/_staff/attendance-engine/_layout/attendance-units/$unitId/')({
  validateSearch: zodValidator(AttendanceDetailEditModeSearchSchema)
});